// frontend/src/components/homepage/artefacts/BiRadar.js
//
// Tile 08's artefact: a radar with a rotating sweep (`hl-sweep`, 3s) and three
// blips fading on the same period, 1s apart (`hl-blipFade`). Positions and
// delays are static classes in featuresLive.css rather than inline styles, so
// the whole artefact is one static rule set. Under motion-off the sweep sits
// at 0deg and every blip is lit - a static radar.

import React, { memo } from "react";

export const BLIP_COUNT = 3;

function BiRadar() {
  return (
    <div className="hl-ft-radar" aria-hidden="true">
      <div className="hl-ft-sweep" />
      <i className="hl-ft-bl hl-ft-bl1" />
      <i className="hl-ft-bl hl-ft-bl2" />
      <i className="hl-ft-bl hl-ft-bl3" />
    </div>
  );
}

export default memo(BiRadar);
